import { render, staticRenderFns } from "./CreateReturnOrderDispatch.vue?vue&type=template&id=736194c1&scoped=true&"
import script from "./CreateReturnOrderDispatch.vue?vue&type=script&lang=js&"
export * from "./CreateReturnOrderDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736194c1",
  null
  
)

export default component.exports